// @ts-strict-ignore
import {
  Directive,
  EventEmitter,
  HostBinding,
  HostListener,
  Output,
  Input
} from '@angular/core';
import { NgModel } from '@angular/forms';

@Directive({
  selector:  '[ngModel][lm-displayupper]',  // tslint:disable-line
  providers: [ NgModel ]
})
export class LMFieldUpperCaseDirective {

  @HostBinding('class.lm-uppercase') isUpper = false;

  @Input() public set isUpperCase(value: boolean | string) {
    if (typeof value === 'string') {
      this.isUpper = (value === 'true');

    } else {
      this.isUpper = value;
    }
  };

  @Output() ngModelChange: EventEmitter<any> = new EventEmitter();


  constructor() {
  }

  // updates the model with the transformed value
  // change event occurs before a blur event
  // input event occurs between keypress and keyup events
  @HostListener('change', [ '$event' ])
  onInputChange(event) {
    if (event && event.target && event.target.value && this.isUpper) {
      const value = event.target.value.toUpperCase();
      this.ngModelChange.emit(value);
    }
  };
}
